<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Internet Banking</h1>
    <p>During your pre-engagement questionnaire you indicated that you would like make payments to employees and HMRC yourself using your Internet Banking.</p>
    <p>As part of this, where your bank is supported, we can generate a payment file in the correct format for your bank. </p>
    <p>You’ll be able to download the file and upload it directly to your online banking system to process the payments.</p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>